<template>
	<div class="scene-wrapper">
		<AccountBanner class="account-banner" v-anchor="'AccountBalance'" />
		<ul class="budget-group" >
			<li class="budget-item" v-for="budget in budgets" :key="budget.id" v-anchor.group="{
					name: 'BudgetSlider',
					meta: { type: budget.id },
				}" >
				<BudgetSlider v-bind="budget" />
			</li>
		</ul>
		<Button class="budget-btn" :action="set" :disabled="!canAdvance">Set Budget</Button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccountBanner from '@/components/game/budget/AccountBanner';
import BudgetSlider from '@/components/game/budget/BudgetSlider';
import Button from '@/components/base/Button';

export default {
	name: 'Budget',
	components: {
		AccountBanner,
		BudgetSlider,
		Button,
	},
	computed: {
		...mapGetters("game/budgets", {
			budgets: "ordered",
			unallocated: "unallocated",
		}),
		totalAllocated() {
			return this.budgets.reduce((total, budget) => total + budget.allocated, 0);
		},
		canAdvance() {
			return this.unallocated === 0;
		},
	},
	methods: {
		set() {
			this.$router.push('/game/budget/complete');
			this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.account-banner {
		margin: 0 auto 50px;

		@include mobile { margin: 0 auto 5vh; }
	}

	.budget-group {
		width: 85%;
		display: grid;
		grid-template-columns: 33% 33% 33%;
		grid-template-rows: auto;
		justify-items: center;
		grid-gap: 40px 20px;

		@include mobile {
			grid-gap: 10px;
			grid-template-columns: 50% 50%;
		}

		@include desktop {
			width: 1000px;
			grid-gap: 40px 20px;
		}
	}

	.budget-item {
		display: flex;
		justify-content: center;
		align-items: center;

		&:nth-child(6) /deep/ .label {
			color: $body-txt-color !important;
		}
	}

	.budget-btn {
		margin: 0 auto;

		@include tablet { margin: 50px auto 0; }
		@include desktop { margin: 50px auto 10vh; }
		@include desktop-sm { margin: 50px auto 0; }
	}
</style>



// WEBPACK FOOTER //
// src/components/game/scenes/Budget.vue